import React, { useRef } from 'react';
import { useStatCountUp } from './hooks';

const Stat: React.FC<{ target: number; decimals: number; suffix: string; label: string; extra?: React.ReactNode }> = ({
  target,
  decimals,
  suffix,
  label,
  extra
}) => {
  const ref = useRef<HTMLSpanElement>(null);
  useStatCountUp(ref, target, decimals, suffix);
  return (
    <div className="stat-cell">
      <div className="stat-num">
        <span ref={ref}>0</span>
        {extra}
      </div>
      <div className="stat-label">{label}</div>
    </div>
  );
};

interface Testimonial {
  initial: string;
  quote: string;
  name: string;
  store: string;
  delay: number;
}

const REVIEWS: Testimonial[] = [
  {
    initial: 'F',
    quote: "This app has been life-changing. The quizzes are super informative, and the audio section is fantastic. I've never had a tool like this.",
    name: 'F.H.',
    store: 'App Store',
    delay: 1
  },
  {
    initial: 'R',
    quote: 'Like deen buddy but 10x better. I test myself every day and remember Allah every day in one single app. Alhamdulilah for this.',
    name: 'Rawhan',
    store: 'App Store',
    delay: 2
  },
  {
    initial: 'Z',
    quote: 'An excellent, stunning app. The guidance is straight to the point and rooted in Islamic scholarship. An example of how technology can be used for good.',
    name: 'Z.A.',
    store: 'App Store',
    delay: 3
  },
  {
    initial: 'A',
    quote: 'Mashallah, this app has genuinely helped me build a consistent relationship with the Quran. The 5-minute daily habit is exactly what I needed as a busy professional.',
    name: 'A.M.',
    store: 'Google Play',
    delay: 1
  },
  {
    initial: 'S',
    quote: 'I love how every answer comes with a Quran reference and scholar verification. Finally an Islamic app I can trust completely. Highly recommend to every Muslim.',
    name: 'Sarah K.',
    store: 'Google Play',
    delay: 2
  },
  {
    initial: 'L',
    quote: 'As a revert, I had so many questions I was too embarrassed to ask. Niyyah answered them all without judgment, with actual Islamic sources. It changed everything for me.',
    name: 'Layla T.',
    store: 'App Store',
    delay: 3
  }
];

const Proof: React.FC = () => (
  <section id="proof">
    <div className="proof-inner">
      <div className="stats-row reveal">
        <Stat target={200} decimals={0} suffix="K+" label="Muslims" />
        <Stat
          target={4.8}
          decimals={1}
          suffix=""
          label="Average rating"
          extra={<span style={{ color: 'var(--gold)', fontSize: '.7em', marginLeft: 2 }}>★</span>}
        />
        <Stat target={674} decimals={0} suffix="+" label="Verified reviews" />
      </div>

      <div className="reviews-header reveal">
        <p className="eyebrow">Reviews</p>
        <h2 className="reviews-h2">
          Real Muslims. <em>Real practice.</em>
        </h2>
      </div>

      <div className="reviews-track">
        {REVIEWS.map((r, i) => (
          <div key={i} className={`testimonial-card reveal reveal-delay-${r.delay}`}>
            <div className="testimonial-stars">★★★★★</div>
            <p className="testimonial-quote">{r.quote}</p>
            <div className="testimonial-author">
              <div className="testimonial-avatar">{r.initial}</div>
              <div>
                <div className="testimonial-name">{r.name}</div>
                <div className="testimonial-store">{r.store}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Proof;
